/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 01.06.17.
 */

import React from "react";
import PropTypes from "prop-types";

class ErrorNotFound extends React.Component {
    static propTypes = {
        error: PropTypes.object,
        errorInfo: PropTypes.object
    };

    render() {
        return (
            <div className="middle-box text-center animated fadeInDown">
                <h1>404</h1>
                <h3 className="font-bold">Page Not Found</h3>

                <div className="error-desc">
                    Sorry, but the page you are looking for has not been found.<br/>
                    You can go to main page: <br/><a href="/" className="btn btn-primary m-t">Main page</a>
                </div>
                <div dangerouslySetInnerHTML={{ __html: '<!-- ' + this.props.error + ' -->' }} />
                <div dangerouslySetInnerHTML={{ __html: '<!-- ' + this.props.errorInfo + ' -->' }} />
            </div>
        );
    }
}

export default ErrorNotFound;
